// extracted by mini-css-extract-plugin
module.exports = {"galleryContainer":"presslist-module--galleryContainer--14gne","h3Gallery":"presslist-module--h3Gallery--2Zuov","h4Gallery":"presslist-module--h4Gallery--ixKt4"};